import React from 'react'; // Needed for ESLint if JSX transform isn't recognized
import logoPng from '../assets/images/icons/Little Explorers Daycare_Logo.png';

// Define styles **before** using them
const styles = {
  wrapper: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Arial, sans-serif',
  },
};

function Maintenance() {
  return (
    <div style={styles.wrapper}>
      <img
        src={logoPng}
        style={{
          width: '250px',
          height: '67px',
          marginBottom: '25px',
        }}
        alt=""
      />
      <h1>We’ll be back soon</h1>
      <p>Our site is currently under maintenance.</p>
    </div>
  );
}

export default Maintenance;
